import { TestInDistrictDetialByData } from '@Src/_basic/object/TestInDistrictType';
import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  row: TestInDistrictDetialByData;
}
export default function CreaterNameColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.createrName}</Typography>;
}
